import { createReducer } from "@reduxjs/toolkit";
import { resetTeacherRequestTeacherPayout, teacherRequestTeacherPayout } from "./request-teacher-payout";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const teacherrequestTeacherPayoutReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(teacherRequestTeacherPayout.pending, state => {
      state.processing = "pending";
    })
    .addCase(teacherRequestTeacherPayout.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(teacherRequestTeacherPayout.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetTeacherRequestTeacherPayout, () => initialState);
});
